import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { AxiosCommonError } from '../../../../../../../shared/types';
import { handleError } from '../../../../../../ui/err/handleError';

import { queries } from '../../../../../../../shared/queries';
import { ICheckFileNameParams } from '../../../../../../../shared/apis/ai-agent/manual/types';

export function useCheckDuplicateFileName(params: ICheckFileNameParams) {
  return useQuery({
    ...queries.aiAgent.checkFileName(params),
    enabled: false,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
